import ApiService from '@/core/api/api.service';
import TokenService from '@/core/api/token.service';
import store from '@/store';

import { functionsWithNotifications } from '@/core/notifications';
import logoutMessages from './logout.messages';

export default functionsWithNotifications({ logout }, logoutMessages);

const authApi = new ApiService({
  baseUrl: store.getters.umBaseUrl,
  addAuthToken: false,
});

async function logout() {
  try {
    const token = TokenService.getAuthToken();
    TokenService.removeAuthToken();
    store.commit('resetUser');
    await authApi.delete(`auth/${token}`);
  } finally {
    window.open(store.state.config.authRedirectUrl, '_self');
  }
}
